<template>
  <div class="normal-header-box show-flex-box-r show-flex-center" @click="slideUpSearchBox()">
    <dl class="show-flex-box-r">
      <dt class="show-flex-box-r">
        <h1 class="show-flex-box-r show-flex-center" @click="opendHomePages('index')">
          <img src="@/assets/publick/header_logo.png" alt="中国书法" /> 
        </h1>
        <ul class="nav-content-list-box show-flex-box-r">
          <li
            class="show-flex-box-r show-flex-center"
            :class="{'tag-selected': item.type == curRoutePathName}"
            v-for="(item,index) in navClassList"
            :key="index"
            @click="opendHomePages(item.type)"
          >
            <strong>{{item.name}}</strong>
          </li>
        </ul>
      </dt>
      <dd class="show-flex-box-r">
        <div class="external-link show-flex-box-r show-flex-center">
          <span @click="openExternal('ccpdo')">数字传播应用</span>
          <span @click="openExternal('zgsfxg')">书法学馆平台</span>
        </div>
        <div class="header-search-box show-flex-box-r">
          <span class="show-flex-box-r">
            <!-- <form autocomplete="off"> -->
              <input
                type="text"
                placeholder="请输入要搜索的内容"
                @keyup.enter="routeToSearchResaultPage()"
                @click.stop="slideDownSearchBox()"
                @blur="searchBoxBlur()"
                v-model="searchContent"          
              />
            <!-- </form> -->
            <!-- <input
                type="text"
                placeholder="请输入要搜索的内容"
                @keyup.enter="routeToSearchResaultPage()"
                @click.stop="slideDownSearchBox()"
                @blur="searchBoxBlur()"
                v-model="searchContent"
                autocomplete="off"
              /> -->
            
            <strong @click="delectedSearchContent()"
                    v-if="searchContent && searchContent.length > 0">
            </strong>
            <em @click="routeToSearchResaultPage()"></em>
          </span>

          <!--搜索内容  -->
          <div
            class="search-box show-flex-box-r"
            :class="{'search-blur': searchBoxFocus}"
            @click.stop="clickSearchBox()"
          >
            <div class="hot-search-box show-flex-box-c" v-if="searchContent.length == 0">
              <h3>热门搜索</h3>
              <ul class="show-flex-box-c">
                <li
                  class="show-flex-box-r"
                  v-for="(item, index) in hotSearchList"
                  :key="index"
                  @click="selectedSearchContent(item)"
                >
                  <span class="hide-line1">{{item.word}}</span>
                </li>
              </ul>
            </div>
            <div class="hot-search-box show-flex-box-c" v-else>
              <h3>相关搜索</h3>
              <ul class="show-flex-box-c" v-if="relatedSearchList && relatedSearchList.length > 0">
                <li
                  class="show-flex-box-r"
                  v-for="(item, index) in relatedSearchList"
                  :key="index"
                  @click="selectedSearchContent(item)"
                >
                  <span class="hide-line1" v-html="item.word_name"></span>
                </li>
              </ul>
              <div class="show-flex-box-r show-flex-center" v-else>
                <span>暂无相关搜索</span>
              </div>
            </div>
          </div>
        </div>
        <dl class="header-login-register-box">
          <dt class="show-flex-box-r" v-if="!isLogined">
            <strong @click="getClickInfo('login')">登录</strong>
            <em></em>
            <strong @click="getClickInfo('register')">注册</strong>
          </dt>
          <dd class="show-flex-box-c" v-else>
            <span class="show-flex-box-r" @click="openMyHomePages()">
              <em class="show-flex-box-r">
                <img :src="userInfo.avatar" @error="onHandleAvatarError($event)" />
              </em>
              <strong>{{userInfo.showname}}</strong>
            </span>
            <ul class="show-flex-box-c">
              <li class="show-flex-box-r">
                <h3 class="show-flex-box-r" v-if="startupData">
                  <span
                    class="show-flex-box-r"
                    @click="openNextPage('/web/my/message_center')"
                  >消息中心（{{startupData.un_read_message_count}}）</span>
                  <em v-if="startupData.un_read_message_count > 0"></em>
                </h3>
              </li>
              <li class="show-flex-box-r" @click="openNextPage('/web/my/personal_data')">
                <span>个人中心</span>
              </li>
              <li class="show-flex-box-r" @click="openNextPage('/web/my/bought_live')">
                <span>已购</span>
              </li>
              <li class="show-flex-box-r" @click="openNextPage('/web/my/collect')">
                <span>收藏</span>
              </li>
              <li class="show-flex-box-r" @click="openNextPage('/web/my/watch_record')">
                <span>记录</span>
              </li>
              <!-- <li class="show-flex-box-r" @click="openNextPage('/web/my/wallet')">
                <span>钱包（¥{{userInfo.wallet}}）</span>
              </li> -->
              <li class="show-flex-box-r" @click="logout">
                <span>退出登录</span>
              </li>
            </ul>
          </dd>
        </dl>
      </dd>
    </dl>
  </div>
</template>

<script>
import regex from "@/filter/regex";
import login from "@/views/login/login";
import register from "@/views/login/register";
import WebIM from "@/utils/WebIM";

export default {
  name: "home",
  data() {
    return {
      // 用户请求服务端热门搜索关键词用
      searchHotTypeMap : {
        'index': 'payment_information',
        'liveHome': 'live',
        'discoverHome': 'image_text ',
      },
      navClassList: [
        { type: "index", name: "首页" },
        // { type: "liveHome", name: "直播" },
        { type: "discoverHome", name: "发现" },
      ],
      curRoutePathName: "index",
      searchContent: "",
      searchBoxFocus: false,
      isClickSearchBox: false,
      isLogined: false,
      userInfo: null,
      startupData: null,
      hotSearchList: [],
      relatedSearchList: [],
      easelogined: false,
    };
  },
  components: {
    login,
    register
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    },
    listenStartupData: function() {
      return this.$store.state.startup;
    },
    listenUserInfo: function() {
      return this.$store.state.user;
    },
    listenLoginPopShowStatus: function() {
      return this.$store.state.loginPopShowStatus;
    },
    listenWebImErrorCode: function() {
      return this.$store.state.webImErrorCode;
    },
  },
  created() {
    this.curRoutePathName = this.$route.name;
    this.checkUserLoginStatus();
  },
  watch: {
    listenToken: function() {
      let tokenStatus = regex.isTrueResult(this.listenToken);

      if (tokenStatus) {
        this.$store.dispatch("reqUpdateUserInfo");
        this.getStartupData();
      } else {
        this.isLogined = false;
      }
    },
    listenUserInfo: function() {
      this.userInfo = this.listenUserInfo;

      this.checkEaseChatHandleByUserInfo();
      this.checkUserStatusThenGetUserInfo();
    },
    listenWebImErrorCode: function() {
      this.nextHandleByWebImErrorCode();
    },
    listenStartupData: function() {
      this.startupData = this.listenStartupData;
    },
    listenLoginPopShowStatus: function() {
      this.setLoginPopShowStatus();
    },
    $route: function(to, from) {
      this.curRoutePathName = to.name;
    },
    searchContent: function() {
      this.reqKeyWordMatching()
    }
  },
  mounted() {
    this.reqHotSearchList();
    this.getStartupData();
  },
  methods: {
    checkUserLoginStatus: function() {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        // 更新重新获取用户信息
        this.$store.dispatch("reqUpdateUserInfo");
        this.getStartupData();
        this.checkUserStatusThenGetUserInfo();
      }
    },
    checkUserStatusThenGetUserInfo: function() {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.isLogined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
        // this.$store.dispatch("setlocalEncryptPublicKey");
      } else {
        this.userInfo = {};
        this.isLogined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    onHandleAvatarError(event) {
      const imgUrl = require('@/assets/logo.png');
      event.target.src = imgUrl;
    },
    //用户信息数据类型转换
    formatUserInfoByType: function(userStore) {
      let userObj = userStore;

      return userObj;
    },
    // 获取用户开始状态
    getStartupData: function() {
      this.$client
        .getStartupData()
        .then(res => {
          if (res.code == 200) {
            this.startupData = res.data;
            this.$store.commit("GET_START_UP", this.startupData);
          }
        })
        .catch(err => {

        });
    },
    setLoginPopShowStatus: function() {
      var showStatus = this.listenLoginPopShowStatus;
      
      if (showStatus) {
        this.$parent.$refs.login.colseLoginWin();
      } 
    },
    opendHomePages: function(index) {
      this.curRoutePathName = index;
      if (index == "index") {
        this.$router.push({ path: "/web/home" });
      } else if (index == "liveHome") {
        this.$router.push({ path: "/web/live" });
      } else {
        this.$router.push({ path: "/web/discover" });
      }
    },
    openMyHomePages: function() {
      this.curRoutePathName = "";
      this.$router.push({ path: "/web/my" });
    },

    reqHotSearchList: function() {
      var params = {
        type:"tv_all"
      };
      this.$client
        .getHotSearchList(params)
        .then(res => {
          if (res.code == 200) {
            this.hotSearchList = res.data.list;
          }
        })
        .catch(err => {
     
        });
    },
    delectedSearchContent: function() {
      this.searchContent = "";
    },
    slideDownSearchBox: function() {
      this.searchBoxFocus = true;
    },
    slideUpSearchBox: function() {
      this.searchBoxFocus = false;
    },
    clickSearchBox: function() {
      this.isClickSearchBox = true;
    },
    searchBoxBlur: function() {
      var _this = this;
      setTimeout(() => {
        if (_this.isClickSearchBox) {
          _this.isClickSearchBox = false;
          return;
        }
        _this.searchBoxFocus = false;
      }, 300);
    },
    reqKeyWordMatching: function() {
      var params = {
        keywords: this.searchContent,
        type:"all"
      };

      this.$client.getKeyWordMatching(params)
      .then(ret=>{
        if(ret.code == 200) {
          var keyWords = ret.data.keywords;
          var keyWordSearchList = ret.data.list;
          this.relatedSearchList = this.filtersKeyWordLsit(keyWords,keyWordSearchList);
        }
      }).catch(err=> {
        
      })

    },
    filtersKeyWordLsit: function(keyWords,keyWordSearchList) {
      var relatedSearchList = [];
      let replaceReg = new RegExp(keyWords, 'g')
      let replaceString = '<em class="search-text">' + keyWords + '</em>'
      for (var i = 0; i < keyWordSearchList.length; i++) {
        var searchString = keyWordSearchList[i];
        searchString.word_name = keyWordSearchList[i].word;
        if(!searchString.word){
          return
        };
        if (keyWords && keyWords.length > 0) {
          searchString.word_name = searchString.word.replace(replaceReg, replaceString)
        };
        relatedSearchList.push(searchString)
      };
      return relatedSearchList;

    },
    openExternal(type) {
      const linkMap = {
        ccpdo: 'https://www.ccpdo.cn',
        zgsfxg: 'https://zgsfxg.com'
      };

      !!linkMap[type] && window.open(linkMap[type],'_blank');
    },
    // 搜索
    routeToSearchResaultPage: function() {
      var searchKeyWords = this.searchContent;
      if(!!this.searchContent){
        this.$router.push({ path: "/web/index/search_result", query:{keyword:searchKeyWords}});
      };
      this.slideUpSearchBox()
    },
    selectedSearchContent: function(item) {
      this.searchContent = item.word;
      this.routeToSearchResaultPage();
     ;
    },
    getClickInfo: function(type) {
      if (type == "login") {
        this.$parent.$refs.login.colseLoginWin();
      } else {
        this.$parent.$refs.register.colseRegisterWin();
      }
    },
    openNextPage: function(path) {
      this.$router.push({ path: path });
    },
    // 环信用户登录 start
    checkEaseChatHandleByUserInfo: function() {
      // var userInfo = this.listenUserInfo;
      // var easemobUser = userInfo ? userInfo.easemob_user : null;
      // if (easemobUser) {
      //   this.easeChatLogin(easemobUser);
      // } else {
      //   this.easeChatLogout();
      // }
    },
    easeChatLogin: function(easemobUser) {
      if (this.easelogined) {
        return;
      }

      let easeName = easemobUser.easemob_username;
      let easePwd = easemobUser.easemob_pwd;

      let options = {
        apiUrl: WebIM.config.apiURL,
        user: easeName,
        pwd: easePwd,
        appKey: WebIM.config.appkey,
        success: function(token) {
          console.log("--webIM：登录成功了--");
        },
        error: function(err) {
          console.log("--webIM：登录失败了--");
        }
      };

      WebIM.conn.open(options);
      this.easelogined = true;
    },
    easeChatLogout: function() {
      if (this.easelogined) {
        return;
      }

      this.easelogined = false;
      WebIM && WebIM.conn && WebIM.conn.close();
    },
    nextHandleByWebImErrorCode: function() {
      var errorCode = this.listenWebImErrorCode;

      switch (errorCode) {
        case 206:
          this.easeChatLogout();
          this.easelogined = false;
          this.checkEaseChatHandleByUserInfo();
        break;
      }
    },
    // 环信用户登录 end
    logout: function() {
      // this.easeChatLogout();
      this.$store.commit("LOGOUT");

      setTimeout(()=> {
        if (this.$route.path != '/web/index') {
          this.$router.replace("/web/index");
        }
      },500)
    }
  }
};
</script>
<style lang="less" scoped>
.normal-header-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  z-index: 99;
  background: #ffffff;
  box-shadow: 0px 0px 8px 3px rgba(0, 0, 0, 0.04);
  & > dl {
    height: 100%;
    align-items: center;
    justify-content: center;
    & > dt {
      align-items: center;
      & > h1 {
        flex-shrink: 0;
        height: 45px;
        &> img {
          display: block;
          height: 30px;
        }
      }
      > ul {
        align-items: center;
        height: 100%;
        margin-left: 61px;
        > li {
          height: 100%;
          cursor: pointer;
          > strong {
            width: 92px;
            height: 70px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 70px;
            text-align: center;
          }
        }
        .tag-selected {
          > strong {
            background: #cb1309;
            color: #ffffff;
          }
        }
      }
    }
    & > dd {
      align-items: center;
      margin-left: 80px;
      &>.external-link {
        margin-right: 20px;
        &>span {
          border-left: 2px solid #333;
          white-space: nowrap;
          padding-left: 10px;
          margin-right: 10px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &:hover {
            text-decoration: underline;
            color: #cb1309;
          }
        }
      }
      & > .header-search-box {
        width: 300px;
        position: relative;
        align-items: center;
        margin-right: 30px;
        & > span {
          padding: 0px 15px;
          width: 270px;
          height: 36px;
          border-radius: 18px;
          border: 1px solid #e3e3e3;
          align-items: center;
          // & > form{
          //   flex-grow: 1;
          //   height: 36px;
          //   line-height: 36px;
          //   font-size: 14px;
          //   font-family: PingFangSC-Regular, PingFang SC;
          //   font-weight: 400;
          //   color: #333333;
          //   margin-right: 5px;
            & > input {
              flex-grow: 1;
              height: 36px;
              line-height: 36px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              margin-right: 5px;
            }
          // }
          // & > input {
          //   flex-grow: 1;
          //   height: 36px;
          //   line-height: 36px;
          //   font-size: 14px;
          //   font-family: PingFangSC-Regular, PingFang SC;
          //   font-weight: 400;
          //   color: #333333;
          //   margin-right: 5px;
          // }
          & > strong {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            background: url("../../assets/discover/pic_delete_icon.png")
              no-repeat center center;
            background-size: 100% 100%;
            cursor: pointer;
          }
          & > em {
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            background: url("../../assets/publick/search_icon.png") no-repeat
              center center;
            background-size: 100% 100%;
            margin-left: 10px;
            cursor: pointer;
          }
        }
        & > .search-box {
          overflow: hidden;
          position: absolute;
          top: 40px;
          left: 0;
          width: 300px;
          height: 0px;
          background: #ffffff;
          -webkit-transition: height 0.2s ease-in-out;
          transition: height 0.2s ease-in-out;
          & > .hot-search-box {
            width: 100%;
            > h3 {
              padding: 15px 24px 5px 24px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
            }
            & > ul {
              width: 317px;
              align-items: center;
              overflow-y: scroll;
              overflow-x: hidden;
              > li {
                width: 302px;
                height: 40px;
                align-items: center;
                cursor: pointer;
                &>span {
                  padding: 0px 24px;
                  line-height: 40px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  -webkit-transition: all 0.2s;
                  transition: all 0.2s;
                  color: rgba(51, 51, 51, 1);
                  &>em{
                    font-size:14px;
                    color: #CB1309;
                  }
                }
              }
              &>li:hover {
                background: #cb1309;
                &>span {
                  color: #fff;
                  -webkit-transition: all 0.2s;
                  transition: all 0.2s;
                  &>em.search-text{
                    font-size:14px;
                    color: #fff;
                  }
                }
              }
            }
            & > div {
              width: 100%;
              height: 100%;
              > span {
                display: block;
                font-size: 15px;
                font-weight: 500;
                line-height: 18px;
                color: #837e7e;
                word-break: break-all;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
              }
            }
          }
        }
        & > .search-blur {
          width: 300px;
          height: 252px;
          background: #ffffff;
          -webkit-transition: height 0.2s ease-in-out;
          transition: height 0.2s ease-in-out;
          box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.05);
          border-radius: 6px;
          overflow: hidden;
        }
      }
      & > dl {
        flex-shrink: 0;
        > dt {
          flex-shrink: 0;
          align-items: center;
          > strong {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            cursor: pointer;
          }
          > em {
            width: 1px;
            height: 10px;
            background: #333333;
            margin: 0px 20px;
          }
        }
        > dd {
          flex-shrink: 0;
          position: relative;
          > span {
            align-items: center;
            cursor: pointer;
            > em {
              display: block;
              width: 28px;
              height: 28px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 11px;
              flex-shrink: 0;
              > img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            > strong {
              flex-shrink: 0;
              white-space: normal;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }
          > ul {
            overflow: hidden;
            position: absolute;
            top: 35px;
            right: 0;
            width: 200px;
            height: 0px;
            -webkit-transition: height 0.2s ease-in-out;
            transition: height 0.2s ease-in-out;
            z-index: 0;
            background: #fff;
            border-radius: 6px;
            box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.05);
            > li {
              flex-shrink: 0;
              width: 100%;
              height: 44px;
              cursor: pointer;
              > h3 {
                flex-shrink: 0;
                padding: 0px 24px;
                height: 44px;
                // align-items: center;
                > span {
                  line-height: 44px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                }
                > em {
                  display: block;
                  flex-shrink: 0;
                  width: 8px;
                  height: 8px;
                  background: rgba(203, 19, 9, 1);
                  border-radius: 100%;
                  overflow: hidden;
                  margin-top: 11px;
                }
              }
              > span {
                flex-shrink: 0;
                padding: 0px 24px;
                height: 44px;
                line-height: 44px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
            > li:nth-child(1) {
              margin-top: 10px;
            }
            > li:nth-last-child(1) {
              margin-bottom: 10px;
            }
            > li:hover {
              background: #cb1309;
              > h3 {
                > span {
                  color: #fff;
                }
              }
              > span {
                color: #fff;
              }
            }
          }
        }
        > dd:hover {
          > ul {
            // height: 329px;
            height: 282px;
            -webkit-transition: height 0.2s ease-in-out;
            transition: height 0.2s ease-in-out;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
  .search-box {
    .hot-search-box {
      &>ul {
        &>li {
          &>span {
            &>em {
              color: #cb1309;
            }
          }
        }
        &>li:hover {
          &>span {
            &>em.search-text {
              color: #fff;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/publick/header_cpn.vue